import AppPageTitle from '@/components/AppPageTitle';
import AppTable from '@/components/AppTable';
import AppTableQuery from '@/components/AppTableQuery';
import { Col, Space } from 'antd';
import React, { useState } from 'react';
import { getRegisterCancelHistory } from '@/services/customer_care.service';
import usePaginatedQuery from '@/hooks/usePaginatedQuery';
import { formatDate, columnSorter } from '@/utils/formatters';
import dayjs from 'dayjs';
import { getActiveBadge } from '@/utils/getActiveBadge';
import ErrorStatusWithDetails from '@/components/common/ErrorStatusWithDetails';
import AppSelect from '@/components/AppSelect';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';

// const checkStatus = (record) => {
//   const errorCodeSuccess = ['0', '411', '412', '414', '204', '205', '402', '405', '501'];
//   if (record?.action === 'CANCEL' && errorCodeSuccess.includes(record?.error_code)) {
//     return true;
//   }

//   if (record?.action !== 'CANCEL') {
//     if (record?.error_code === '0') {
//       return true;
//     } else {
//       return false;
//     }
//   }

//   return false;
// };

const filterOptions = [
  {
    label: 'All',
    value: null,
  },
  {
    label: 'Success',
    value: 1,
  },
  {
    label: 'Fail',
    value: 0,
  },
];

const filterReasonOptions = [
  {
    label: 'All',
    value: null,
  },
  {
    label: 'REG',
    value: 'REG',
  },
  {
    label: 'CANCEL',
    value: 'CANCEL',
  },
  {
    label: 'RENEW',
    value: 'RENEW',
  },
  {
    label: 'BUY',
    value: 'BUY',
  },
  {
    label: 'BUY_HEART',
    value: 'BUY_HEART',
  },
];

const START_DATE = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
const END_DATE = dayjs().format('YYYY-MM-DD');

function RegisterCancelHistory() {
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(1);
  const offset = (pageIndex - 1) * pageSize + 1;
  const [time, setTime] = useState([START_DATE, END_DATE]);
  const [searchValue, setSearchValue] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [selectedFilterReason, setSelectedFilterReason] = useState(null);
  const [query, setQuery] = useState({
    isdn: null,
    status: null,
    reason: null,
    start_date: time[0],
    end_date: time[1],
  });
  const { data, isLoading, refetch, isRefetching } = usePaginatedQuery(
    () =>
      getRegisterCancelHistory({
        ...query,
        limit: pageSize,
        offset: offset,
      }),
    ['charge-history', query, pageSize, offset]
  );
  const handleQuery = () => {
    setQuery({
      isdn: searchValue,
      start_date: time[0],
      end_date: time[1],
      status: selectedFilter,
      reason: selectedFilterReason,
    });
    setPageIndex(1);
  };
  const handleReset = () => {
    setQuery({
      isdn: null,
      status: null,
      start_date: START_DATE,
      end_date: END_DATE,
      reason: null,
    });
    setSelectedFilter(null);
    setSearchValue(null);
    setTime([START_DATE, END_DATE]);
    setPageIndex(1);
  };

  const onFilterChange = (val) => setSelectedFilter(val);
  const onReasonFilterChange = (val) => setSelectedFilterReason(val);

  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);

  const columns = [
    {
      title: 'Phone Number',
      dataIndex: 'isdn',
      key: 'isdn',
      fixed: isMobile ? 'left' : '',
      sorter: columnSorter('isdn'),
      render: (isdn) => (isdn ? isdn : '-'),
    },
    {
      title: 'Pack ID',
      dataIndex: 'package_code',
      key: 'package_code',
      sorter: columnSorter('package_code'),
      render: (text) => (text ? text : '-'),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (_, record, __) => {
        const result = record?.status_code?.status === 1;
        const renderStatus = getActiveBadge(result, {
          activeText: 'Success',
          inactiveText: 'Fail',
        });
        const message = record?.status_code?.message || 'No details';
        if (!result) {
          return (
            <ErrorStatusWithDetails content={message}>
              <span>{renderStatus}</span>
            </ErrorStatusWithDetails>
          );
        }

        return <span>{renderStatus}</span>;
      },
    },
    {
      title: 'Register Time',
      dataIndex: 'request_time',
      key: 'request_time',
      render: (text, record, index) => {
        return record.action === 'CANCEL' ? '-' : formatDate(text);
      },
    },
    {
      title: 'Cancel Time',
      dataIndex: 'request_time',
      key: 'request_time',
      render: (text, record, index) => {
        return record.action === 'CANCEL' ? formatDate(text) : '-';
      },
    },
    {
      title: 'Channel',
      dataIndex: 'channel',
      key: 'channel',
      sorter: columnSorter('channel'),
      render: (text) => (text ? text : '-'),
    },
    {
      title: 'Reason',
      dataIndex: 'action',
      key: 'action',
      sorter: columnSorter('action'),
      render: (text) => (text ? text : '-'),
    },
  ];

  return (
    <Space direction="vertical" className="w-full">
      <AppPageTitle title="Register/Cancel History" />
      <AppTableQuery
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        hasDatePicker={true}
        // filterOptions={filterOptions}
        // filterLabel="Status"
        // filterPlaceholder="Status"
        // selectedFilter={selectedFilter}
        // setSelectedFilter={setSelectedFilter}
        customFilter={
          <>
            {/* <Col span={isMobile ? 24 : 4}>
              <AppSelect
                items={filterOptions}
                value={selectedFilter}
                placeholder="Status"
                title="Status"
                onChange={onFilterChange}
                label="Status"
                formItemClassName={'mb-0'}
              />
            </Col> */}
            <Col span={isMobile ? 24 : 4}>
              <AppSelect
                items={filterReasonOptions}
                placeholder="Reason"
                title="Reason"
                label={'Reason'}
                formItemClassName={'mb-0'}
                value={selectedFilterReason}
                onChange={onReasonFilterChange}
              />
            </Col>
          </>
        }
        searchPlaceholder="Phone number"
        time={time}
        setTime={setTime}
        rangePicker
        timeLabel="Register Time"
        timePlaceholder="Register Time"
        handleQuery={handleQuery}
        handleReset={handleReset}
      />

      <AppTable
        columns={columns}
        dataSource={data?.data}
        totalItems={data?.total}
        loading={isLoading || isRefetching}
        onRefresh={refetch}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPageChange={(page, size) => {
          setPageIndex(page);
        }}
        onPageSizeChange={(newSize) => {
          setPageSize(newSize);
        }}
      />
    </Space>
  );
}

export default RegisterCancelHistory;
